import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { IncidentMapping } from '../../models/Mapping';
import { Card } from './Card';

interface CardListProps {
  mappings: IncidentMapping[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onEdit?: (mapping: IncidentMapping) => void;
  couriersMap?: Map<number, { id: number; name: string; image_hash?: string | null }>;
}

export const CardList = ({
  mappings,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  onEdit,
  couriersMap,
}: CardListProps) => {
  const renderCard = (props: RenderItemProps<IncidentMapping>) => (
    <Card mapping={props.item} onEdit={onEdit} couriersMap={couriersMap} />
  );

  return (
    <VirtualList
      data={mappings}
      renderItem={renderCard}
      itemKey={(m) => m.id ?? Math.random()}
      estimateItemHeight={160}
      height="calc(100vh - 150px)"
      gap={0}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
